import axios from 'axios';
import ReactDOM from 'react-dom';
import Loading from '../base/Loading';
import { toast, clearToast } from './toast';
import Gzip from './gzip';
import { getBusinessInfo } from './getBusinessInfo';
import { getParamByLocation, isUndefined } from './utils';
import { setCookie, getCookie } from './cookie';
import { setGlobalStorage, getGlobalStorage } from './storage';
import handelExitPage from './exit.js';
import Cipher, { opaqueDecrypt, encrypt, decrypt } from './cipher';
import { syncAjax } from './ajaxsync';
import * as broadcastChannel from './broadcastChannel';
import { getAppReqParam } from './appUrlUtils';
import forwardUrl from './forwardUrl';
import { getParentWindow, getTopWindow } from './window.js';
import { localeLang } from './currentLocale';
import { encryptFormData } from './formDataEncrypt';
import Cryptograph from './cryptograph';
import { getDocument } from './qiankunContext.js';
import ViewModel from './viewmodel';

import { apiExtend } from '../FastExtend'; // 为了标志这个文件也适配了客开  不建议去除
window.__reloadAjax = window.__reloadAjax || [];
const excludeCipherUrl = {
    "/nccloud/riart/login/init.do": true,
    "/nccloud/riart/login/verfiy.do": true,
    "/nccloud/login/psw/reset.do": true,
    "/nccloud/riart/login/forpsw.do": true,
    "/nccloud/riart/login/toreset.do": true,
    "/nccloud/riart/login/rand.do": true,
    "/nccloud/baseapp/thirdPartyLogin/thirdPartyVerfiy.do": true,
    "/nccloud/platform/query/automated.do": true,
    "/nccloud/platform/gzip/switch.do": true,
    "/nccloud/platform/localstorage/switch.do": true,
    "/nccloud/platform/mark/switch.do": true,
    "/nccloud/platform/extendstyle/switch.do": true,
    "/nccloud/platform/aes/switch.do": true,
    "/nccloud/platform/total/switch.do": true,
};

// 缓存一些常量用来做多页签（tab）通信
const sscopenkey = getParamByLocation(window.location.hash, 'sscopenkey'); // 共享服务可能不再使用
const urlDataC = getParamByLocation(window.location.hash, 'c') || getAppReqParam().appcode;
const urlDataP = getParamByLocation(window.location.hash, 'p') || getAppReqParam().pagecode;

// 压缩工具
const gziptools = new Gzip();

let stack = [], containerTemp = [];
const DEFAULT_DELAY_TIME = 1000;
const SERVICE_TIP = localeLang === 'simpchn' ? '服务不可用' : 'Service Unavailable';
const NETWORK_TIP = localeLang === 'simpchn' ? '网络错误' : 'Network Error';
/**
 * 一、明确需求
 * - 发起远程调用：基本的url、method、data、success、error、headers、timeout、async————通用能力
 * - loading遮罩————通用能力
 * - 加密、压缩————NCC能力
 * 
 * 二、api设计
 * - 导出的方法名：ajax
 * - ajax的参数：见下
 * - ajax的返回值：见下
 * 
 * 三、代码设计
 * - 见下
 */

/**
 * 一、函数参数默认值有两种策略
 * 1、由最终导出的函数统一设置默认值
 * 2、由每个子函数各自设置默认值
 * 
 * 二、尽量避免...rest传参，除非明确知道rest里有哪些参数
 */

/**
 * @namespace Ajax
 */

/**
 * ajax参数说明
 * @memberof Ajax
 * @typedef ajaxParams
 * @property {string} url 请求的url
 * @property {string} method='post' 请求类型
 * @property {Object} data 请求数据
 * @property {boolean} async=true 是否为异步请求，默认为异步请求
 * @property {Object} headers={'Content-Type':'application/json;charset=UTF-8'} 请求头
 * @property {Object} params 请求参数
 * @property {boolean} isGzip=true 是否启用gzip
 * @property {boolean} isEncrypt=true 是否启用加密
 * @property {boolean} isDecrypt=true 是否启用解密
 * @property {number} timeout 请求超时的毫秒数
 * @property {function} success 请求成功的回调
 * @property {function} error 请求失败的回调
 * @property {boolean} encryptForm=false 是否启用表单数据加密
 * @property {string} mode 异步请求下，mode === 'normal'，直接返回请求数据
 * @property {boolean} loading=true 是否使用loading遮罩
 * @property {number} delayTime=1000 显示loading遮罩的延迟
 * @property {HTMLElement} loadingContainer loading遮罩的渲染容器
 * @property {HTMLElement} windowContainer=window 放置loading遮罩的渲染容器的容器
 * @property {HTMLElement} toastContainer 错误提示信息的渲染容器
 * @property {string} sysAppcode 自定义sysParamJson中的appcode 参数
 * @property {string} from sysParamJson 中的 from 参数
 * @property {string} sysActionName sysParamJson中的 busiaction 参数
 * @property {Object} sysParameter 自定义sysParamJson， 注意：sysParameter 优先级大于 from 和 sysActionName
 * @property {Object} systemData 自定义系统参数，合并到sysParamJson
 * @property {string} print=false 是否为打印接口
 * @property {string} isUpload=false 是否为附件接口
 * @property {function} uploadResponse 附件接口回调方法
 * @property {function} getCompleteErrorInfo 获取完整堆栈信息
 */

/**
 * ajax方法描述
 * @memberof Ajax
 * @param {ajaxParams} ajaxParams - ajax函数参数
 * @returns {Promise} 
 */
function ajax(ajaxParams) {
    let {
        url = '',
        method = 'post',
        params = {},
        async = true,
        success = defaultSuccessCallback,
        error ,
        headers = { 'Content-Type': 'application/json;charset=UTF-8' },
        isGzip = true,
        isEncrypt = true,
        isDecrypt = true,
        encryptForm = false,
        mode = '',
        loading = true,
        loadingContainer,
        windowContainer = window,
        sysAppcode,
        print = false,
        isUpload = false,
        uploadResponse = defaultUploadResponseCallback,
        getCompleteErrorInfo = defaultGetCompleteErrorInfo,
        authorizeError = defaultGetCompleteErrorInfo,
    } = ajaxParams;

    //let loadingWrapper;
    // // modify by wangyang
    // loadingWrapper = windowContainer.document.createElement('div');
    // windowContainer.document.body.appendChild(loadingWrapper);
    // loadingWrapper.className = 'base-loading-hidden'; 
    //console.error(url,"ajax请求开始");

    typeof getTopWindow().startAjax === 'function' && getTopWindow().startAjax(url);
    let hasCustomErrorHandler = true;
    if(error===undefined){
        error = defaultErrorCallback;
        hasCustomErrorHandler = false;
    }

    // 处理系统参数，配置请求数据
    //模板中配置的url与该处相同，在系统参数中加autoSerach
    let newData = setSysParam(ajaxParams, url);

    // 获取 设置时区
    getTimeZone(ajaxParams);

    // 扩展开发发送请求前修改data
    let extendParams = beforeAjaxSend({ data: newData, ajaxUrl: url, method, params });
    newData = extendParams.data;
    // 数据加签
    let { ajaxHeader, ajaxData } = addDataSign(newData, { allin: true, headers, sysAppcode });

    // 分流
    forwardUrl({ ...ajaxParams }, newUrl => { //修改url后发请求
        let newParams = {
            ...ajaxParams,
            url: newUrl,
            method,
            headers: ajaxHeader,
            data: ajaxData,
            params,
            isGzip,
            isEncrypt,
            isDecrypt,
            encryptForm,
            mode,
            handelExitPage,
            success,
            error,
            print,
            isUpload,
            uploadResponse,
            getCompleteErrorInfo,
            authorizeError,
            loading,
            loadingContainer,
            windowContainer,
            hasCustomErrorHandler
        };
        //执行ajax请求
        if (async) {
            //异步
            asyncAxios(newParams);
        } else {
            //同步
            syncAxios(newParams);
        }
        //处理完后，在viewmodal中删掉
        ViewModel.setData('searchUrlCache', null);
    });
}

export default ajax;

//异步请求
function asyncAxios(axiosParams) {
    let {
        method,
        params,
        headers,
        url,
        data,
        loading,
        loadingContainer,
        mode,
        success,
        error,
        authorizeError,
        getCompleteErrorInfo,
        toastContainer,
        delayTime,
        windowContainer,
        hasCustomErrorHandler
    } = axiosParams;
    let exitFlag = true;
    //先获取viewmodal中的变量
    axios({
        method,
        params,
        headers,
        url,
        data,
        withCredentials: true,
        transformRequest: [
            function (data) {
                loading && showLoading({ windowContainer, delayTime, loadingContainer, url });
                // 如果 form-data 方式提交  不进行加密压缩
                if (headers['Content-Type'] == 'multipart/form-data') {
                    return data;
                }
                let gData = '';
                gData = gzip({ ...axiosParams, data });
                gData = cipher({ ...axiosParams, data: gData });
                return gData;
            },
        ],
        transformResponse: [
            function (data, headers) {
                loading && hideLoading({ loadingContainer, windowContainer, delayTime, url });
                // 处理401
                exitFlag = handelExitPage(headers, true, authorizeError);
                if (headers.environmentmodel) {
                    getTopWindow().environmentmodel = headers.environmentmodel;
                }
                if (exitFlag) {
                    let result = null;
                    result = unCipher({ ...axiosParams, data });
                    result = unGzip({ ...axiosParams, data: result });
                    return result;
                } else {
                    return null;
                }
            },
        ],
    })
        .then(res => {
            if (res) {
                typeof getTopWindow().endAjax === 'function' && getTopWindow().endAjax(url);
                if (mode === 'normal') {
                    handleSuccess({ res, url, success });
                } else {
                    if ((res.data && res.data.success) || res.success) {
                        handleSuccess({ res: res.data, url, success });
                    } else {
                        getCompleteErrorInfo(res);
                        if (!errorStatusCatchHandle(res, error, url, res.headers,hasCustomErrorHandler)) {
                            return null;
                        }
                        error(res.data && res.data.error, url, toastContainer);
                    }
                }
            }
        })
        .catch(res => {
            if (exitFlag) {
                let data = res;
                if (!errorStatusCatchHandle(data, error, url, res.response ? res.response.headers : {})) {
                    return null;
                }
                if (!networkErrorStatusCatchHandle(res.request, res.error || res, error, url)) {
                    return;
                }
                let message = res.message;
                if (typeof message === 'string') {
                    res.message = errorMessageCatchHandle(res);
                    if (res.message !== message) {
                        error(res, url, toastContainer);
                        return;
                    }
                }
                try {
                    data = unCipher({ ...axiosParams, data });
                    data = typeof data === 'string' ? unGzip({ ...axiosParams, data }) : data;
                    // 添加 特殊接口响应状态的判断 如400
                    if (data.response && data.response.data) {
                        data = data.response.data;
                        data = data.error || data;
                    }
                    error(data, url, toastContainer);
                } catch (e) {
                    error(data, url, toastContainer);
                }

            } else {
                // 添加 特殊接口响应状态的判断 如400
                // if (res.response && res.response.data) {
                // 	res = res.response.data;
                // }
                // error(res, url);
                if (res.response.status === 401) {
                    new Promise(resolve => {
                        window.__reloadAjax.push(resolve);
                    }).then(res => {
                        if (res === true) {
                            asyncAxios(axiosParams);
                        }
                    });
                }
            }
        });
}

//同步请求
function syncAxios(axiosParams) {
    let {
        method,
        headers,
        url,
        data,
        loading,
        loadingContainer,
        success,
        error,
        getCompleteErrorInfo,
        authorizeError,
        async,
        isUpload,
        uploadResponse,
        delayTime,
        windowContainer,
    } = axiosParams;
    //同步
    let requestData = gzip({ ...axiosParams, data });
    requestData = cipher({ ...axiosParams, data: requestData });
    syncAjax({
        type: method,
        url, //添加自己的接口链接
        data: requestData,
        async,
        headers,
        before() {
            loading && showLoading({ windowContainer, delayTime, loadingContainer, url });
        },
        success(str, xhr) {
            loading && hideLoading({ windowContainer, loadingContainer, delayTime, url });
            // 附件请求base64
            if (isUpload) {
                uploadResponse(str);
            } else {
                try {
                    typeof getTopWindow().endAjax === 'function' && getTopWindow().endAjax(url);
                    let res = null;
                    str = unCipher({ ...axiosParams, data: str });
                    res = unGzip({ ...axiosParams, data: str });
                    if (res.success) {
                        handleSuccess({ res, url, success });
                    } else {
                        getCompleteErrorInfo(res);
                        if (!errorStatusCatchHandle(res, error, url, xhr ? { 'nccloud-service': xhr.getResponseHeader('Nccloud-Service') || '' } : {})) {
                            return null;
                        }
                        //throw new Error(res.error.message);
                        error(res.error, url);
                    }
                } catch (e) {
                    error(e, url);
                }
            }
        },
        error(status, statusText, headers = {}, xhr) {
            loading && hideLoading({ loadingContainer, delayTime, url });
            let exitFlag = handelExitPage(headers, true, authorizeError);
            if (!exitFlag) {
                return;
            }
            if (!networkErrorStatusCatchHandle(xhr, statusText, error, url)) {
                return;
            }
            error(statusText, url);
        },
    });
}

// 压缩
function gzip(params) {
    let { isGzip, print, data } = params;
    let NCC_SYS_Switch = getSysSwitch();
    let useGzip = isGzip && NCC_SYS_Switch.gzip && !print;
    return useGzip ? gziptools.zip(JSON.stringify(data)) : JSON.stringify(data);
}

// 解压缩
function unGzip(params) {
    let { isGzip, print, data } = params;
    let NCC_SYS_Switch = getSysSwitch();
    let useGzip = isGzip && NCC_SYS_Switch.gzip && !print;
    return useGzip ? gziptools.unzip(JSON.stringify(data)) : (isJSON(data) ? JSON.parse(data) : data);
}

// 加密
function cipher(params) {
    let { url, isDecrypt, isEncrypt, headers, print, data } = params;

    // 获取秘钥
    const cryptograph = new Cryptograph();
    let crux = String(headers['crux'] || (new Date().getTime()));
    let aeskey = cryptograph.getCacheSecretKey({ crux });
    // 获取加密开关
    let NCC_SYS_Switch = getSysSwitch();
    let useEncrypt = !excludeCipherUrl[url] && isEncrypt && isDecrypt && NCC_SYS_Switch.aesKey && !print;
    return useEncrypt ? cryptograph.symmetricEncrypt(data, aeskey) : data;
}

// 解密
function unCipher(params) {
    let { url, print, isDecrypt, isEncrypt, headers, data } = params;
    // 获取秘钥
    const cryptograph = new Cryptograph();
    let crux = String(headers['crux'] || (new Date().getTime()));
    let aeskey = cryptograph.getCacheSecretKey({ crux });
    // 获取解密开关
    let NCC_SYS_Switch = getSysSwitch();
    let useDecrypt = !excludeCipherUrl[url] && typeof data === 'string' && isDecrypt && isEncrypt && NCC_SYS_Switch.aesKey && !print;
    if (url === '/nccloud/riart/login/logout.do') {
        useDecrypt = false;
    }
    return useDecrypt ? cryptograph.symmetricDecrypt(data, aeskey) : data;
}

// 处理系统参数，配置请求数据
function setSysParam(params, url) {
    let { sysAppcode, sysActionName, sysParameter, from = '', headers = {}, data = {}, encryptForm, systemData } = params;
    // 获取 app appcode custom
    let { app, appcode, custom } = getAppReqParam();
    appcode = sysAppcode || appcode || '10228888';
    // 获取并设置 cookiets
    let cookiets = String(headers['cookiets'] || ((top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now()));
    setCookie('cookiets', cookiets);
    top && (getTopWindow().cookiets = cookiets);
    let sysParamJson = {};
    let tabid = getTopWindow().WebSocketTabid || '';
    let newData = data;
    let busiaction = '';
    if (sysActionName) {
        busiaction = sysActionName;
    } else {
        busiaction = window.actionName ? app + '-' + window.actionName : app;
    }
    if (sysParameter) {
        sysParamJson = sysParameter;
        sysParamJson.pagecs = cookiets;
        let strData = typeof data === 'string' ? data : JSON.stringify(data);
        if (typeof systemData === 'object') {
            sysParamJson = { ...sysParamJson, ...systemData };
        }
        newData = {
            busiParamJson: strData,
            sysParamJson,
        };
    } else {
        if (headers['Content-Type'] == 'multipart/form-data') {
            sysParamJson = {
                sys_busiaction: busiaction,
                sys_appcode: appcode,
                sys_tabid: getTopWindow().WebSocketTabid || '',
                sys_ts: String(new Date().getTime()),
                sys_custom: custom || '',
            };
            if (typeof systemData === 'object') {
                sysParamJson = { ...sysParamJson, ...systemData };
            }
            if (encryptForm) {
                //与formDownlod一样加密
                //添加加密后系统参数
                newData.append('sysParamJson', encryptFormData(JSON.stringify(sysParamJson)));
                newData.append('sys_appcode', appcode);
                //获取业务参数加密
                let decryptbusiParam = encryptFormData(newData.get('busiParamJson'));
                newData.set('busiParamJson', decryptbusiParam);
            } else {
                for (let key in sysParamJson) {
                    newData.append(key, sysParamJson[key]);
                }
            }
        } else {
            //在这里取viewModal中存的url
            let autoSearchUrlArr = ViewModel.getData('searchUrlCache', autoSearchUrlArr) || [];
            sysParamJson = {
                busiaction,
                appcode,
                tabid,
                ts: new Date().getTime(),
                from,
                pagecs: cookiets,
            };
            if (autoSearchUrlArr && autoSearchUrlArr.includes(url)) {
                sysParamJson.autoSearch = true;
            }
            if (custom) {
                sysParamJson.custom = custom;
            }
            if (typeof systemData === 'object') {
                sysParamJson = { ...sysParamJson, ...systemData };
            }
            let strData = typeof data === 'string' ? data : JSON.stringify(data);
            newData = {
                busiParamJson: strData,
                sysParamJson,
            };
        }
    }
    return newData;
}

// 设置 headers 加签
function addDataSign(data, {
    allin = false,
    headers = {},
    sysAppcode = '',
    useNccSign,
}) {
    // 获取加签开关
    if (!useNccSign) {
        let NCC_SYS_Switch = getSysSwitch();
        useNccSign = NCC_SYS_Switch.mark;
    }
    // 获取 userCode
    let userInfos = getBusinessInfo();
    let userCode = userInfos?.userCode;
    // 设置 headers
    let newHeaders = { ...headers };
    let cookiets = String(newHeaders['cookiets'] || ((top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now()));
    newHeaders['cookiets'] = cookiets;
    let { appcode } = getAppReqParam();
    appcode = sysAppcode || appcode || '10228888';
    newHeaders['transcode'] = newHeaders['transcode'] || appcode;
    let crux = String(headers['crux'] || (new Date().getTime()));
    newHeaders['crux'] = crux;
    if (
        !useNccSign ||
        typeof transSn === 'undefined' ||
        typeof transSign === 'undefined' ||
        (headers && headers['Content-Type'] == 'multipart/form-data') // newData.append(  这种模式 先确定下 需不需要加签操作
    ) {
        return { ajaxHeader: newHeaders, ajaxData: data };
    }
    // 先加签全部数据 或者部分数据

    // 这里会影响原字符串 （编码、位数？）导致后台解析不了字符串
    if (!allin) {
        let strDataSign = data.busiParamJson + '';
        // 加签 -- bbqin
        data.sysParamJson.sn = transSn(userCode);
        data.sysParamJson.signdata = transSign(strDataSign, userCode);
    } else {
        // 加签 -- bbqin
        // data.sysParamJson.sn = transSn(userCode);
        let dataStr = JSON.stringify(data) + '';
        newHeaders['Identifications'] = transSign(dataStr, '');
    }
    return { ajaxHeader: newHeaders, ajaxData: data };
}

// 处理success
function handleSuccess(params) {
    let { res, url, success } = params;
    res = dealSecDevData({
        res,
        ajaxUrl: url,
        ts: new Date().getTime(),
        c: urlDataC,
        p: urlDataP,
    });
    // 清空当前接口返回的错误toast
    clearToast(url);
    success(res);
    // 添加storage事件触发 by bbqin
    broadcastChannel && broadcastChannel.broadcast(sscopenkey || 'TabBroadcast', {
        ajaxUrl: url,
        sscopenkey,
        ts: new Date().getTime(),
        c: urlDataC,
        p: urlDataP,
    });
}

// 显示loading
function showLoading({
    windowContainer,
    delayTime,
    loadingContainer,
    url,
}) {
    //console.log(`当前请求url为${url}，显示loading`);
    let loadingTime = isUndefined(delayTime) ? DEFAULT_DELAY_TIME : delayTime;
    let container = null;
    setTimeout(() => {
        if (stack.length > 0 && container) {
            container.className = 'base-loading-show';
            if (!loadingContainer) {
                container.classList.add('ajax-full-screen');
            }
            console.log("延迟显示loading");
        }
    }, loadingTime);
    let appElement = getDocument();
    if (loadingContainer) {
        container = windowContainer.document.createElement('div');
        appElement.appendChild(container);
        container.className = 'base-loading-hidden';
        ReactDOM.render(<Loading show={true} container={loadingContainer} />, container);
        containerTemp.push({ url, container, private: true });
    } else {
        stack.push(url);
        if (stack.length === 1) {
            container = windowContainer.document.createElement('div');
            appElement.appendChild(container);
            container.className = 'base-loading-hidden';
            container.setAttribute("data-name", "base-loading");
            ReactDOM.render(<Loading show={true} fullScreen container={container} />, container);
            containerTemp.push({ url, container, private: false });
        }
    }
}

// 隐藏loading
function hideLoading({
    loadingContainer,
    delayTime,
    url,
}) {
    let containerItem = containerTemp.find(x => x.url === url);
    if (!loadingContainer) {
        stack.pop();
    }

    if (stack.length === 0 || containerItem?.private) {
        console.log(`当前请求url为${url}，隐藏loading`);

        if (!containerItem) {
            containerItem = containerTemp.find(x => x.private === false);
        }
        if (!containerItem) {
            return;
        }
        let container = containerItem.container;
        containerTemp.splice(containerTemp.findIndex(x => x.url === containerItem.url), 1);
        container.className = '';
        ReactDOM.unmountComponentAtNode(container);
        let loadingTime = isUndefined(delayTime) ? DEFAULT_DELAY_TIME : delayTime;
        setTimeout(() => {
            //container.parentElement && container.parentElement.removeChild(container);
            container.remove();
        }, loadingTime);
    }
}

function defaultSuccessCallback() {
    // 空函数
}

function defaultErrorCallback(res, url, toastContainer) {
    if (!res) { return; }
    console.error(res.type, res, url);
    // 解决NCC-138543 多次转义出现多个 \\ 的问题
    let msgContent = typeof (res.message) === 'string' ? res.message : JSON.stringify(res.message);
    const colors = ['danger', 'warning', 'info', 'success'];
    let color = colors.indexOf(res.type) != -1 ? res.type : 'danger';
    toast({ color, content: errorMessageCatchHandle({ message: msgContent, url }), container: toastContainer, mark: url });
}

function defaultUploadResponseCallback() {

}

function defaultGetCompleteErrorInfo() {

}

// 获取时区
function getTimeZone() {
    let NCC_SYS_Switch = getSysSwitch() || {};
    let gzipFlag = NCC_SYS_Switch.gzip;
    let aesKeyFlag = NCC_SYS_Switch.aesKey;
    // 用户信息获取
    let userInfos = getBusinessInfo();
    let NCC_SYS_Timezone = JSON.parse(localStorage.getItem('NCC_SYS_Timezone'));
    if (!NCC_SYS_Timezone && (userInfos && userInfos.userCode)) {
        let { app, appcode, custom } = getAppReqParam();
        appcode = appcode || '10228888';
        let cookiets = String((getTopWindow().cookiets) || getCookie('cookiets') || Date.now());
        let crux = new Date().getTime();
        let dataParams = {
            sysParamJson: {
                pagecs: cookiets,
                busiaction: '分流',
                ts: new Date().getTime(),
            },
        };
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            'crux': crux,
            'cookiets': cookiets,
            'transcode': appcode,
        };
        let { ajaxData, ajaxHeader } = addDataSign(dataParams, { allin: true, headers });
        dataParams = JSON.stringify(ajaxData);
        if (gzipFlag) {
            dataParams = gziptools.zip(dataParams);
        }
        //let { url, isDecrypt, isEncrypt, headers, print, data } = params;
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/pub/timezone.do',
            async: false,
            headers: ajaxHeader,
            data: cipher({ 
                url: '/nccloud/platform/pub/timezone.do', 
                isDecrypt: true, 
                isEncrypt: true, 
                headers: ajaxHeader, 
                print: false, 
                data: dataParams 
            }),
            success: res => {
                if (res) {
                    res = typeof res === 'string' ? unCipher({
                        url: '/nccloud/platform/pub/timezone.do', 
                        isDecrypt: true, 
                        isEncrypt: true, 
                        headers: ajaxHeader, 
                        print: false, 
                        data: res, 
                    }) : res;
                    if (gzipFlag) {
                        res = gziptools.unzip(res);
                    } else if (isJSON(res)) {
                        res = JSON.parse(res);
                    }
                    if (res.data) {
                        NCC_SYS_Timezone = res.data;
                        localStorage.setItem('NCC_SYS_Timezone', JSON.stringify(NCC_SYS_Timezone));
                    } else {
                        defaultErrorCallback(res, '/nccloud/platform/pub/timezone.do');
                    }
                }
            },
        });
    }
}

// 获取并设置 ajax 开关
function getSysSwitch() {
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    let cookiets = String((top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now());
    if (NCC_SYS_Switch === null) {
        let reqData = {
            sysParamJson: {
                busiaction: '查询系统开关',
                pagecs: cookiets,
                ts: new Date().getTime(),
            },
        };
        let headers = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
        let { ajaxData, ajaxHeader } = addDataSign(reqData, { allin: true, headers, useNccSign: true });
        reqData = JSON.stringify(ajaxData);
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/total/switch.do',
            async: false,
            headers: ajaxHeader,
            data: reqData,
            success: res => {
                if (res) {
                    res = JSON.parse(res);
                    if (res.data) {
                        let NCC_SYS_Switch = res.data || {};
                        let localStorageSwitch = localStorage.getItem('storeCipher');
                        //缓存是否加密开关变化了
                        if (localStorageSwitch != NCC_SYS_Switch.localStorage) {
                            //localStorage加密开关与上次不一致，则清空所有localStorage内容
                            localStorage.clear();
                        }
                        localStorage.setItem('NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                        //开启关闭自动化测试开关
                        localStorage.setItem('storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_automated_', NCC_SYS_Switch.automated_test ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_extend_style_', NCC_SYS_Switch.extendstyle ? '1' : '0');
                    } else {
                        defaultErrorCallback(res, '/nccloud/platform/total/switch.do');
                    }
                }
            },
        });
    }
    NCC_SYS_Switch = NCC_SYS_Switch || JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    return NCC_SYS_Switch;
}

// 错误信息
function unexpectedTip() {
    let message = '';
    message = localeLang === 'simpchn' ? '服务断开。请检查网络连接，或者联系管理员' : 'Service disconnected. Please check your network connection or contact your administrator';
    return message;
}

// 错误信息catch
function errorMessageCatchHandle(props) {
    let message = props.message;
    if (message.indexOf('Unexpected') != -1 && message.indexOf('token') != -1 && message.indexOf('JSON') != -1) {
        return unexpectedTip();
    }
    if (message.indexOf('Malformed') != -1 && message.indexOf('UTF-8') != -1 && message.indexOf('data') != -1) {
        return unexpectedTip();
    }
    // sarfari
    if (message.indexOf('SyntaxError') != -1 && message.indexOf('JSON') != -1 && message.indexOf('Unexpected') != -1) {
        return unexpectedTip();
    }
    return props.message;
}

// 处理错误信息 处理network error 以及 Failed to execute 'send' on 'XMLHttpRequest'
function networkErrorStatusCatchHandle(request = {}, error = {}, tipCallBack, url) {
    let data = { type: 'danger', message: NETWORK_TIP };

    // error.name 同步的是请求是NetworkError  异步的时候没有名称
    // 默认报错拦截处理
    const defaultMessage = typeof (error.message) === 'string' ? error.message : JSON.stringify(error.message);

    const messageKey1 = "Failed to execute 'send' on 'XMLHttpRequest";
    const messageKey2 = "Network Error";

    if (defaultMessage && request.status === 0 && request.readyState === 4 &&
        (defaultMessage.includes(messageKey1) || defaultMessage.includes(messageKey2))
    ) {
        // data.message = `${NETWORK_TIP}; url:${url}`;
        data.message = `${NETWORK_TIP}`;
        tipCallBack && tipCallBack(data, url);
        return null;
    }
    return true;
}

// 处理错误信息 目前主要处理 500
function errorStatusCatchHandle(response = {}, tipCallBack, url, headers = {},hasCustomErrorHandler) {
    if (status === 4147) {
        toast({ color: 'danger', content: '数据不能解析（解压或解密)' });
        return null;
    }
    let data = { type: 'danger', message: SERVICE_TIP },
        status = response.status || (response.response ? response.response.status : 200);
    if (status === 500 || status === 501 || status === 503 || status === 502) {
        data.message = `${headers['nccloud-service'] || ''} ${SERVICE_TIP}; url:${url},status: ${status}`;
        // 清理ncc
        data.message = data.message.replace(/nccloud\//g, '');
        tipCallBack && tipCallBack(data, url);
        return null;
    }
    if (status === 504) {
        data.message = `${headers['nccloud-service'] || ''} ${localeLang === 'simpchn' ? '网关超时' : 'Gateway Timeout'}; url:${url},status: ${status}`;
        data.message = data.message.replace(/nccloud\//g, '');
        tipCallBack && tipCallBack(data, url);
        return null;
    }
    if (status === 429) {
        data.message = `${headers['nccloud-service'] || ''} ${localeLang === 'simpchn' ? '系统繁忙，请稍后再试' : 'Too Many Requests'}; url:${url},status: ${status}`;
        data.message = data.message.replace(/nccloud\//g, '');
        tipCallBack && tipCallBack(data, url);
        return null;
    }
    const errorCodeArray = response?.data?.error?.errorcode;

    if (Array.isArray(errorCodeArray)) {
        const idArray = response?.data?.error?.errorpk;
        const msgArray = response?.data?.error?.messages;

        if (errorCodeArray.length != idArray.length) {
            toast({ content: "错误码配置异常，请联系实施人员", color: 'danger' });
            return;
        }

        const status = 'browse';
        const type = 'view';
        const appcode = '10181826';
        const pagecode = '10181826_card';
        const contentMeta = [];
        errorCodeArray.forEach((item, index) => {
            contentMeta.push({
                title: '\n ${error}:${content} \n ${watchDetail}',
                fields: {
                    error: {
                        action: 'text',
                        display: item,
                    },
                    content: {
                        action: 'text',
                        display: msgArray[index],
                    },
                    watchDetail: {
                        action: 'pageTo',
                        display: '查看详情',
                        params: { id: idArray[index], status, type, appcode, pagecode, isview: 'true', msg: msgArray[index] },
                        sysParams: { isSkipPower: true },

                    },
                },
            });

        });

        toast({
            contentMeta,
            color: 'danger',
            type:'errorCode',
            usePunctuation:false,
        });
        return hasCustomErrorHandler;
    }
    return response;
}

// 扩展开发获取数据后修改data
function dealSecDevData(params) {
    let data = apiExtend('dataAlreadyLoaded', params);
    return data || params.res;
    // let data = ViewModel.dataAlreadyLoaded && ViewModel.dataAlreadyLoaded(params);
    // return data || params.res;
}

// 扩展开发发送请求前修改data
function beforeAjaxSend(params) {
    let data = apiExtend('beforeAjaxSend', params);
    return data || params;
    // let data = ViewModel.beforeAjaxSend && ViewModel.beforeAjaxSend(params);
    // return data || params;
}

// 判断json数据
function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
    console.log('It is not a string!');
}

export { ajax };
